import { render } from "./app-shell.vue?vue&type=template&id=f51803f6&ts=true"
import script from "./app-shell.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-shell.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shell/app-shell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f51803f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f51803f6', __exports__)) {
    api.reload('f51803f6', __exports__)
  }
  
  module.hot.accept("./app-shell.vue?vue&type=template&id=f51803f6&ts=true", () => {
    api.rerender('f51803f6', render)
  })

}


export default __exports__